<template>
    <div class="rule">
        <div class="index_cont">
            <!--        <img :src="require('../../assets/index/facula.png')" alt="" class="bgF">-->
            <!--        <div class="bgFacula"></div>-->
            <img :src="require('@/assets/index/logo_main.png')" alt="" class="index_logo">
            <img :src="require('@/assets/index/title.png')" alt="" class="index_title">
            <div class="rule_main">
                <p class="rule_main_tit">活动规则</p>
                <p class="rule_main_p"> <span class="fw">1、</span>点击首页【即刻成为大使】，根部提示生成大使海报</p>
                <p class="rule_main_p"> <span class="fw">2、</span>保存生成的海报，前往微博进行发布，发布的文字内容需包含
                    <span class="fw">@仙妮蕾德sunrider</span>和<span class="fw">#我就是“仙”女大使#</span>才视为活动参与成功
                </p>
                <p class="rule_main_p">
                    <span class="fw">3、</span>
                    活动时间：2021年5月9日-5月16日，请于活动时间内生成海报发布微博哦~
                </p>
                <p class="rule_main_p">
                    <span class="fw">4、</span>
                    5月17日，我们将会根据微博总互动（转发+评论+点赞总和）筛选前10位参与用户进行二轮投票，投票总数前三的用户每人将获得爱莲组合一份，
                    同时会在所有参与发布微博的用户中，随机抽取5人寄送爱莲眼霜一份
                </p>
                <p class="rule_main_p">
                    <span class="fw">5、</span>
                    最终中奖结果将于2021年5月20日
                    <span class="fw">@仙妮蕾德sunrider</span>
                    微博中公布，如对活动有任何疑问请及时联系仙妮蕾德官方微博微信
                </p>
                <p class="rule_main_p">
                    <span class="fw">6、</span>
                    本次活动的最终解释权归仙妮蕾德（中国）有限公司
                </p>
            </div>
            <img @click="goBack" :src="require('@/assets/rule/btn.png')" alt="" class="rule_btn">
        </div>

    </div>
</template>

<script>
  export default {
    data(){
      return {

      }
    },
    methods:{
      goBack(){
        this.$router.go(-1)
      }
    }
  }
</script>

<style scoped lang="less">
    .rule{
        width: 100%;
        height: 100%;
        background-image: url('../../assets/index/bg.png');
        background-size: cover;
        background-position: 50%;
        background-repeat: no-repeat;
        box-sizing: border-box;
        position: relative;
        overflow: auto;
        .index_cont{
            padding-top: 94px;
            box-sizing: border-box;
            width: 100%;
            height: 100%;
            background-image: url("../../assets/index/facula.png");
            background-size: cover;
            background-position: 50%;
            background-repeat: no-repeat;
            .bgFacula{
                width: 100%;
                height: 100%;
                background-image: url('../../assets/index/facula.png');
                background-size: cover;
                background-position: 50%;
                position: absolute;
                top: 0;
                left: 0;
                z-index: 1;
            }
            .bgF{
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
                z-index: 2;
            }
            .index_logo{
                width: 110px;
                height: 85px;
                margin: 0 auto 17px;
            }
            .index_title{
                width: 303px;
                height: 50px;
                margin: 0 auto;
            }
            .rule_main{
                width: 287px;
                height: 330px;
                border-radius: 5px;
                overflow: scroll;
                background-color: #fff;
                padding: 15px;
                box-sizing: border-box;
                margin: 0 auto;
                font-size: 12px;
                font-weight: 400;
                color: #92383A;

                .rule_main_tit{
                    text-align: center;
                    margin-bottom: 15px;
                    font-weight: 700;
                    font-size: 16px;
                }
                .rule_main_p{
                    line-height: 16px;
                    margin-bottom: 12px;
                    .fw{
                        font-weight: 700;
                    }
                }
            }
            .rule_btn{
                width: 136px;
                height: 36px;
                margin: 10px auto 0;
            }
            .rule_btn:active{
                opacity: 0.8;
            }
        }

    }
</style>
